<div class="container">
    <iframe *ngIf="siteId == '3000' " class="responsive-iframe" src="https://minidashboard-spm-dz-cloud.azurewebsites.net"></iframe>
</div>